module.exports = __webpack_public_path__ + "static/media/El Mayor.d1e99f46.jpg";